import React, { useState, useEffect } from "react";
import { inject, observer } from "mobx-react";
import { Dialog, Button, Card } from "@blueprintjs/core";
import "./MultiLevelRatingDialog.css";
import { FilledButton, OutlinedButton } from "../buttons-20250224T111359Z-001/buttons";
import ToastStore from "../../stores/ToastStore";
const RATING_METHODS = [
  { id: 0, title: "Last Rating", description: "Uses the most recent rating value provided by the user" },
  { id: 1, title: "Average Rating", description: "Calculates the mean of all rating values over time" },
];

const MultiLevelRatingMethod = inject("ToastStore")(observer(
  ({  onSave, defaultValue }) => {
    const [selected, setSelected] = useState(defaultValue ?? 0);

    const handleConfirm = () => {
      onSave(selected);
      ToastStore.showToast("Rating method saved successfully", "success");
    };

    return (
      // <Dialog
      //   isOpen={isOpen}
      //   onClose={onClose}
      //   title="Choose Rating Method"
      //   className="rating-method-dialog"
      //   usePortal={true}
      //   portalContainer={document.body}
      // >
        <div className="bp4-dialog-body rating-method-body">
          <p className="rating-subtitle">
            Select the calculation method for ratings in your system
          </p>

          <div className="rating-options-wrapper">
            {RATING_METHODS.map((method) => (
              <div
                key={method.id}
                className={`rating-card ${selected === method.id ? "selected" : ""}`}
                onClick={() => setSelected(method.id)}
              >
                <div className="radio-circle">
                  {selected === method.id && <div className="inner-dot" />}
                </div>

                <div className="rating-card-text">
                  <div className="rating-title">{method.title}</div>
                  <div className="rating-description">{method.description}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="bp4-dialog-footer">
            <div className="bp4-dialog-footer-actions push-20-t">
              <FilledButton
                text="Save"
                onClick={handleConfirm}
              />
              {/* <span onClick={onClose} className="push-10-l" style={{ color: "#1870d5", cursor: "pointer", fontSize: "14px", marginTop: "10px" }}>
                Cancel
              </span> */}
            </div>
          </div>
        </div>
      // </Dialog>
    );
  }
));

export default MultiLevelRatingMethod;
